var NfcTask = /** @class */ (function () {
    function NfcTask(dto) {
        this.projectId = dto.projectId;
        this.projectName = dto.projectName;
        this.tasks = dto.tasks;
    }
    return NfcTask;
}());
export default NfcTask;



//////////////////
// WEBPACK FOOTER
// ./src/models/NfcTask.ts
// module id = 364
// module chunks = 0